module.exports = __webpack_public_path__ + "img/lock_BgWhite.ac741f96.svg";